import request from '@/api/request'

export default {
    getPhonePromptConfig() {
        return request({ url: '/systemRole/phone/admin/config', method: 'get' })
    },
    getPhonePrompt(roleId) {
        return request({ url: '/systemRole/phone/admin/getPrompt', method: 'get', params: { roleId } })
    },
    savePhonePrompt(roleId, prompt) {
        return request({ url: '/systemRole/phone/admin/updatePrompt', method: 'post', data: { roleId, prompt } })
    },
    clearPhonePrompt(roleId) {
        return request({ url: '/systemRole/phone/admin/deletePrompt', method: 'delete', params: { roleId } })
    },

    // 获取全部系统角色（用于简单场景或本地分页）
    listAll(params) {
        return request({
            url: '/systemRole/getAll',
            method: 'get',
            params
        })
    },

    // 分页查询（如果后端提供分页接口）
    getPage(params) {
        return request({
            url: '/systemRole/page',
            method: 'get',
            params
        })
    },

    // 新增系统角色
    create(data) {
        return request({
            url: '/systemRole/create',
            method: 'post',
            data
        })
    },

    // 更新系统角色
    update(data) {
        return request({
            url: '/systemRole/update',
            method: 'post',
            data
        })
    },

    // 删除系统角色
    remove(params) {
        return request({
            url: '/systemRole/delete',
            method: 'post',
            params
        })
    },

    // 设置为默认
    setDefault(params) {
        return request({
            url: '/systemRole/setDefault',
            method: 'post',
            params
        })
    },

    // 上传角色模型文件（模型通常较大，增加超时时间）
    uploadModel(data) {
        return request({
            url: '/systemRole/uploadModel',
            method: 'post',
            data,
            timeout: 300000 // 5 分钟，避免大文件上传被默认 5 秒超时中断
            // 不手动设置 Content-Type，让 axios 自动处理 multipart/form-data 和 boundary
        })
    },

    // 获取角色分组列表
    getGroupList() {
        return request({
            url: '/systemRoleGroup/list',
            method: 'get'
        })
    }
}


